'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Journey = require('./Journey.jsx');

var _Journey2 = _interopRequireDefault(_Journey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Journeys(props) {
  var journeys = props.journeys,
      journeyDurations = props.journeyDurations,
      components = props.components;


  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'Itineraries' },
    _react2.default.createElement(
      'tbody',
      null,
      journeys.map(function (journey, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            { style: { padding: '0px' } },
            _react2.default.createElement(_Journey2.default, { journey: journey, duration: journeyDurations[i] })
          )
        );
      })
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Journeys);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/Journeys.jsx
// module id = 1480
// module chunks = 0